import { useState } from 'react';
import GaugeChart from 'react-gauge-chart'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const RocAucModelGauge = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

    function closeRocModal() {
      setModalOpen(false);
    }

    
    function roc_auc_explain(e) {
        e.preventDefault();
      setModalOpen(true);
    }

    function getRocMessage(_e) {
        const too_high_warning = window.model_high_warning_value;
        const too_high_error = window.model_high_error_value;
        const too_low_error = window.model_low_error_value;
        const good_threshold = window.model_good_threshold;
        const great_threshold = window.model_great_threshold;
        let message;
        if (_e <= too_low_error ) {
            message = "Error";
        } else if (_e > too_low_error && _e < good_threshold) {
            message = "OK";
        } else if (_e >= good_threshold && _e < great_threshold) {
            message = "Good";
        } else if (_e >= great_threshold && _e < too_high_warning) {
            message = "Great";
        } else if (_e >= too_high_warning && _e < too_high_error) {
            message = "Warning";
        } else {
            message = "Error";
        }
        return message;
    }
    
        const _efficacy = props.roc_auc || 0;

        const gauge_neddle = () => {
            if(_efficacy < 0.5) {
                return 0;
            }
            if(_efficacy > 1) {
                return ((1 - 0.5) / 0.5);
            }
            return ((_efficacy - 0.5) / 0.5);
        }

        return (<>
            <div className="roc-auc-gauge">
            <h3>Model Efficacy: ({ _efficacy })
                <button id="info-button" onClick={(e) => roc_auc_explain(e)}>
                    <i className="fa fa-circle-info"/>
                </button></h3>
                <GaugeChart id="gauge-chart3"
                    colors={["#EA4228","#F5CD19", "#007F03", "#F5CD19", "#EA4228"]}
                    arcsLength={[3, 1, 4.2, 0.7, 1.1]}
                    textColor={"#000000"}
                    needleBaseColor={"#888888"}
                    percent={ gauge_neddle() }
                    animateDuration={0}
                    hideText={true}
                />
                <div align={"center"}>
                    <b>{getRocMessage(_efficacy)}</b>
                </div>
                
            </div>
          
            <Modal
                isOpen={modalOpen}
                toggle={() => closeRocModal()}
                backdrop centered>
                <ModalHeader toggle={() => closeRocModal()}>
                    Model Efficacy
                </ModalHeader>
                <ModalBody>
                    <p> To measure a model’s efficacy, we use the ROC AUC metric to determine how well the model can differentiate between the positive (customers) and
                    negative (non-customers) examples in the training data.</p>
                
                    <p>A value of 0.5 indicates a random model – meaning the model cannot correctly rank the training data. A value of 1.0 represents a model
                    that sorts the data with no errors.</p>
                
                    <p>In the marketing domain, we typically expect a usable model to be in the 0.65 to 0.85 range.</p>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => closeRocModal()}>Close</Button>
                </ModalFooter>
            </Modal>
        </>
        );
}

export default RocAucModelGauge;

